<template>
    <div id="modalAlertTips">
        <a @click="closeModal"><span>&times;</span></a>
        <div class="wrapper">
            <img src="static/img/alertcard-modal/Artboard 1.png" alt="">
            <img src="static/img/alertcard-modal/Artboard 2.png" alt="">
            <img src="static/img/alertcard-modal/Artboard 3.png" alt="">
            <img src="static/img/alertcard-modal/Artboard 4.png" alt="">
            <img src="static/img/alertcard-modal/Artboard 5.png" alt="">
            <img src="static/img/alertcard-modal/Artboard 6.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
      methods: {
        closeModal (type) {
          document.body.classList.remove('alertModalOpen')
          this.$store.state.showModal = false
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals/RainAlertModal.vue